export default function initSkipLink() {
    const skipLink = document.querySelector('.skip-link');
    const mainContent = document.getElementById('main-content');

    if (!skipLink || !mainContent) {
        return;
    }

    skipLink.addEventListener('click', (event) => {
        event.preventDefault();
        mainContent.scrollIntoView({ block: 'start' });
        mainContent.focus({ preventScroll: true });
    });
}
